export function isIdpLogin(hash: string): boolean {
  return hash.indexOf('#/idp=') === 0;
}
